import React from "react";
import {
    IoLogoLinkedin,
    IoLogoInstagram,
    IoMdMail,
    IoLogoGithub,
    IoLogoXing,

} from "react-icons/io"
import {
    AiFillMediumSquare
} from "react-icons/ai"
import "./style.scss"
import {person} from "../../store/person";


export class Icons extends React.Component {
    render(): React.ReactElement {
        const ext = { target: "_blank", rel: "noopener noreferrer" };
        return (
            <div>
                {(person.linkedin) ? <a href={person.linkedin} aria-label="LinkedIn profile" {...ext}><IoLogoLinkedin/></a> : null}
                {(person.instagram) ? <a href={person.instagram} aria-label="Instagram profile" {...ext}><IoLogoInstagram/></a> : null}
                {(person.email) ? <a href={"mailto:" + person.email} aria-label="Send email"><IoMdMail/></a> : null}
                {(person.github) ? <a href={person.github} aria-label="GitHub profile" {...ext}><IoLogoGithub/></a> : null}
                {(person.xing) ? <a href={person.xing} aria-label="Xing profile" {...ext}><IoLogoXing/></a> : null}
                {(person.medium) ? <a href={person.medium} aria-label="Medium blog" {...ext}><AiFillMediumSquare/></a> : null}
                {/*<a>Medium</a>*/}
            </div>
        );
    }
}